export default "__VITE_ASSET__783c2321__"